export const ledsClientIds: { [key: string]: string } = {
    sc: '1b9e18c32b89e2f0d354aea572a14849',
    bc: '1b9e18c32b89e2f0d354aea572a14849',
    na: '1b9e18c32b89e2f0d354aea572a14849',
    pgba: '37ee64e9bb51f8e1be849c70f0729706'
};

export type LobType = keyof typeof ledsClientIds;

export const regionCodes: string[] = [
    'DVCST1', 'DVDST1', 'DVEST1', 'DVFST1', 'DVGST1', 'DVHST1', 'DVJST1', 'DVMST1',
    'DVOST1', 'DVPST1', 'DV1ST1', 'DV4ST1', 'DV5ST1', 'DV8ST1', 'DV9ST1', 'LOEST1',
    'DVCUT1', 'DVDUT1', 'DVEUT1', 'DVFUT1', 'DVGUT1', 'DVHUT1', 'DVJUT1', 'DVMUT1',
    'DVOUT1', 'DVPUT1', 'DV1UT1', 'DV4UT1', 'DV5UT1', 'DV8UT1', 'DV9UT1', 'LOEUT1'
];

export type RegionType = typeof regionCodes[number] | null;

export const releaseTags: string[] = [
    'unit-1', 'unit-2', 'unit-3', 'unit-4', 'unit-5', 'unit-6', 'unit-7', 'unit-8',
    'system-1', 'system-2', 'system-3', 'system-4', 'system-5', 'system-6', 'system-7', 'system-8',
    'qa-1', 'qa-2', 'isc1', 'isc2', 'mirror', 'preview', 'demo', 'latest'
];

export type SwimlaneType = typeof releaseTags[number] | null;

export const legacyCommwebServiceBaseUrls: Record<string, string> = {
    'unit-1': 'https://unit-1.myhealthtoolkit.com/',
    'unit-2': 'https://unit-2.myhealthtoolkit.com/',
    'unit-3': 'https://unit-3.myhealthtoolkit.com/',
    'unit-4': 'https://unit-4.myhealthtoolkit.com/',
    'unit-5': 'https://unit-5.myhealthtoolkit.com/',
    'unit-6': 'https://unit-6.myhealthtoolkit.com/',
    'unit-7': 'https://unit-7.myhealthtoolkit.com/',
    'unit-8': 'https://unit-8.myhealthtoolkit.com/',
    'system-1': 'https://system-1.myhealthtoolkit.com/',
    'system-2': 'https://system-2.myhealthtoolkit.com/',
    'system-3': 'https://system-3.myhealthtoolkit.com/',
    'system-4': 'https://system-4.myhealthtoolkit.com/',
    'system-5': 'https://system-5.myhealthtoolkit.com/',
    'system-6': 'https://system-6.myhealthtoolkit.com/',
    'system-7': 'https://system-7.myhealthtoolkit.com/',
    'system-8': 'https://system-8.myhealthtoolkit.com/',
    'qa-1': 'https://qa.myhealthtoolkit.com/',
    'qa-2': 'https://qa2.myhealthtoolkit.com/',
    isc1: 'https://isc1.myhealthtoolkit.com/',
    isc2: 'https://isc2.myhealthtoolkit.com/',
    mirror: 'https://mirror.myhealthtoolkit.com/',
    preview: 'https://preview.bcbssc.com/',
    demo: 'https://demo.myhealthtoolkit.com/',
    latest: 'https://myhealthtoolkit.com/',
    production: 'https://myhealthtoolkit.com/'
};
